import styled from 'styled-components'
import { motion } from 'framer-motion'

export const MotionPanel = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.colors.neutralW20};
  z-index: 1001;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);

  /* Ensure it covers the entire viewport on mobile */
  height: 100vh;
  height: 100dvh; /* Use dynamic viewport height when available */
`

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutralW20};
  background: ${({ theme }) => theme.colors.neutralW20};

  > div:first-child {
    display: flex;
    align-items: center;
  }
`

export const PanelFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 16px 8px;
  border-top: 1px solid ${({ theme }) => theme.colors.neutralW30};
  background: ${({ theme }) => theme.colors.neutralW20};
`

export const PanelContent = styled.div`
  padding: 0 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 20px;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.neutralW20};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.neutralW40};
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.neutralW50};
  }
`

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.neutralW30};
  border-radius: 8px;
`


export const FilterGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;

  /* Custom scrollbar for filter grids */
  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.neutralW30};
    border-radius: 2px;
  }
`

export const FilterOption = styled.button`
  padding: 8px 12px;
  border: 1px solid
    ${({ theme, $isSelected }) =>
      $isSelected ? theme.colors.interact70 : theme.colors.neutralW30};
  border-radius: 20px;
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.interact70 : 'transparent'};
  color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.neutralW10 : theme.colors.neutralW80};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    border-color: ${({ theme }) => theme.colors.interact70};
    background: ${({ theme, $isSelected }) =>
      $isSelected ? theme.colors.interact80 : theme.colors.neutralW20};
  }

  &:active {
    transform: scale(0.98);
  }
`

export const PanelHeaderInnerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`

